import { env } from './env'

export function useDemoOrgId(): string {
  if (!env.demoOrgId) {
    throw new Error('VITE_DEMO_ORG_ID is not configured')
  }
  return env.demoOrgId
}

export function orgPath(suffix: string): string {
  return `/api/v1/${env.demoOrgId}${suffix}`
}
